module.exports = __webpack_public_path__ + "static/media/16.788b4b10.jpg";